import React from "react";
import { useParams } from "react-router-dom";
import { ScreeningResultsUncontrolled } from "./card-uncontrolled";

export const ScreeningResults = () => {
  const { applicationId } = useParams<{
    applicationId: string;
  }>();

  return <ScreeningResultsUncontrolled applicationId={applicationId} />;
};
